import { Injectable, signal, TemplateRef } from '@angular/core';
import { ToastOptions } from '@shared/components/toast/toast.component';
import * as uuid from 'uuid';

// export class Toast {
//   template?: TemplateRef<any>;
//   classname?: string;
//   delay?: number;
// }

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts = signal<ToastOptions[]>([]);

  show(toast: Partial<ToastOptions>) {
    const newToast: ToastOptions = new ToastOptions();
    toast.id = uuid.v4();
    Object.assign(newToast, toast);
    this.toasts.update((toasts) => [...toasts, newToast]);
  }

  remove(toast: ToastOptions) {
    this.toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  clear() {
    this.toasts.set([]);
  }
}

/*
private _set(patch: Partial<TableState<T>>) {
    Object.assign(this._state, {...this._state, ...patch});
 */
